export function getTenantCacheKey(baseKey: string): string {
  if (typeof window === 'undefined') return baseKey
  const slug = window.location.pathname.split('/').filter(Boolean)[0] || 'platform'
  return baseKey + ':' + slug
}
